import React from 'react';
import injectSheet from 'react-jss';
import { Layout, Row } from 'antd';

const { Footer } = Layout;

const styles = () => ({
  root: {
    padding: '2em',
    backgroundColor: '#454545',
    color: '#FFFFFF',
  },

});
const FooterTab = props => (
  <Footer className={props.classes.root}>
    <Row type="flex" justify="center" align="middle">
      Pauline Laborie, Droit public - Tous droits réservés - Mentions légales
    </Row>
  </Footer>
);


export default injectSheet(styles)(FooterTab);



// WEBPACK FOOTER //
// ./src/app/containers/Footer.jsx